/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c3d7920d21840bbdbda77777279aae7>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "EmojiCasual".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing a casual or relaxed tone or sentiment.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const EmojiCasualIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "EmojiCasualIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.776 6.119.279 1.3A2 2 0 0 0 4.01 9h1.054a2.625 2.625 0 0 0 2.61-2.345L7.8 5.5h.4l.124 1.155A2.625 2.625 0 0 0 10.935 9h1.054a2 2 0 0 0 1.956-1.58l.279-1.301a6.5 6.5 0 1 1-12.448 0M13.124 4A6.49 6.49 0 0 0 8 1.5c-2.08 0-3.934.977-5.124 2.5zm-.302 1.5H9.71l.106.995A1.125 1.125 0 0 0 10.935 7.5h1.054a.5.5 0 0 0 .49-.395zm-6.532 0H3.178l.344 1.605a.5.5 0 0 0 .489.395h1.054c.575 0 1.058-.433 1.119-1.005zM.847 4.413A8 8 0 0 1 8 0a8 8 0 1 1 0 16A8 8 0 0 1 .847 4.413m5.238 6.12c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .69-.675l.031-.04.005-.006-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513m4.556-.721" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
EmojiCasualIcon.displayName = 'EmojiCasualIcon';
var _default = exports.default = EmojiCasualIcon;